import { IInvestmentService, IInvestmentFilter } from "./investment_service"
import { IInvestment } from '../schemas/entity_set'
import { IModelController, ModelController } from '../schemas/structure'
import { MessageBox } from '../helpers/message_box';
import { AppServices, AngularServices, Routes } from '../helpers/config_keys'
import { ILookUpService } from '../settings/lookup_service';
let _: UnderscoreStatic = require("underscore")

class InvestmentsCtrl extends ModelController<IInvestment> implements IModelController<IInvestment>  {
    lastFilter: IInvestmentFilter;
    status = ["New", "Approved", "Pending", "Processing", "Completed", "Failed", "Applied"]
    //lookUps = []

    static $inject = [AngularServices.State, AppServices.InvestmentService, AppServices.LookUpService];

    constructor(private $state: angular.ui.IStateService,
        private investmentService: IInvestmentService,
        private lookupService: ILookUpService) {
        super("Investment")
        this.start()
    }

    addNew() {
        this.formTitle = "New Investment"
        this.newRecord = <IInvestment>{}
        this.setUpFormView()
    }

    setStatusLabel(status: string) {
        switch (status) {
            case "Failed":
                return "label label-danger";
            case "Pending":
                return "label label-warning";
            case "Processing":
                return "label label-info";
            case "Completed":
                return "label label-success";
            case "Applied":
                return "label label-primary";
            default:
                return "label label-default";
        }
    }

    open(id: number) { this.$state.go(Routes.Investment, { id }) }

    pageChanged(page: number) {
        this.currentPage = page;
        this.lastFilter.pager.page = page;
        this.loading = true
        this.investmentService.query(this.lastFilter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data
                this.pageNumber = this.currentPage
            }
        })
    }

    fetch(filter: IInvestmentFilter) {
        filter.pager = filter.pager || { page: 1, size: 15 }
        this.lastFilter = angular.copy(filter)
        this.loading = true
        this.investmentService.query(filter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data
                this.totalRecords = res.total;
                this.totalPages = Math.ceil(res.total / this.recordSize);
                this.pageNumber = this.currentPage
            }
        })
    }

    saveRecord(investment: IInvestment) {
        let theInvestment = angular.copy(investment)
        this.saving = true
        this.investmentService.save(theInvestment).then((res) => {
            this.saving = false
            if (res.success) {
                this.closeForm()
                this.fetch(this.lastFilter)
            }
        })
    }

    deleteRecord(investment: IInvestment) {
        MessageBox.confirm("Delete Investment", "Are you sure you want to delete record").then((yes) => {
            if (yes) {
                this.deleting = true
                this.investmentService.delete(investment.id).then((res) => {
                    this.deleting = false
                    if (res.success) {
                        this.closeForm()
                        this.fetch(this.lastFilter)
                    }
                })
            }
        })
    }

    private loadLookUps() {
        let self: any = this;
        // this.lookUps.forEach((lookup) => {
        //     this.lookupService.fetch(lookup).then((res) => {
        //         if (res.success) { self[lookup] = res.data }
        //     })
        // })
    }

    private start() {
        this.loadLookUps()
        this.fetch(<IInvestmentFilter>{})
    }

}

export { InvestmentsCtrl }


// WEBPACK FOOTER //
// ./app/investments/investments_ctrl.ts